// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "app/styles/" + chunkId + "." + {"3607":"092ac4a8ea01e89f4b94","8613":"3cb029b77ffdcd934e3a"}[chunkId] + ".css";
};